import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      boxShadow: 'unset',
      display: 'flex',
      justifyContent: 'space-between'
    },
    tab: {
      backgroundColor: 'white',
      textTransform: 'inherit',
      border: '1px solid',
      padding: '3px 6px',
      borderColor: '#B4D620',
      [theme.breakpoints.up('tablet')]: {
        padding: '8px 12px',
      },
    },
    tabs: {},
  })
)
